import { UserCircle, CheckCircle, Clock, Folders } from 'lucide-react'

import type { TClientApplicationOverview } from '@fingerprinting/types/schemas/application.schema'

export const APPLICATION_DATE = {
  '7days': '7days',
  '30days': '30days',
  '90days': '90days',
  thisyear: 'thisyear',
  lastyear: 'lastyear',
  alltime: 'alltime',
} as const

export const APPLICATION_DATE_OPTIONS = [
  { value: APPLICATION_DATE['7days'], label: '7 days ago' },
  { value: APPLICATION_DATE['30days'], label: '30 days ago' },
  { value: APPLICATION_DATE['90days'], label: '90 days ago' },
  { value: APPLICATION_DATE.thisyear, label: 'This year' },
  { value: APPLICATION_DATE.lastyear, label: 'Last year' },
  { value: APPLICATION_DATE['alltime'], label: 'All time' },
] as const satisfies Array<TSelectOption>

export const [FIRST_DATE_OPTION] = APPLICATION_DATE_OPTIONS

// Keys for percentage change fields
type TChangeKey = 'totalChange' | 'workingChange' | 'approvedChange' | 'inProgressChange'

export const APPLICATION_OVERVIEW_STAT_CARDS = [
  {
    title: 'Total application',
    key: 'total',
    changeKey: 'totalChange' as TChangeKey,
    icon: <Folders className="size-4 text-default" />,
    bgColor: 'bg-[#F05D50]',
  },
  {
    title: 'Working application',
    key: 'working',
    changeKey: 'workingChange' as TChangeKey,
    icon: <UserCircle className="size-4 text-client-amber-400" />,
    bgColor: 'bg-[#1685b1]',
  },
  {
    title: 'Approved',
    key: 'approved',
    changeKey: 'approvedChange' as TChangeKey,
    icon: <CheckCircle className="size-4 text-client-success" />,
    bgColor: 'bg-client-success',
  },
  {
    title: 'In progress',
    key: 'inProgress',
    changeKey: 'inProgressChange' as TChangeKey,
    icon: <Clock className="size-4 text-client-warning" />,
    bgColor: 'bg-client-warning',
  },
] satisfies Array<{
  title: string
  icon: React.ReactNode
  key: keyof TClientApplicationOverview
  changeKey: TChangeKey
  bgColor: string
}>

